<template>
  <div>    
    <VueCal :selected-date="getToday()"
          locale="es"
         :time-from="7 * 60"
         :disable-views="['years', 'year']"
         :editable-events="{ title: true, drag: false, resize: true, delete: true, create: false }"
          hide-weekends
         :events="events"
         @event-title-change="ModificaTexto('event-title-change', $event)"
         @event-duration-change="ModificaTiempo('event-duration-change', $event)"
         :onEventDblclick="onEventClick">
      <template v-slot:no-event>Sin eventos</template>
    </VueCal> 
    <div style="text-align:left;">
      <b-button
        type="is-primary"
        size="is-large"
        class="btn"
        @click="mostrarModalNuevoEvento = true"
        >+</b-button>
      </div>
    <b-modal
      :active.sync="mostrarModalNuevoEvento"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <form @submit.prevent="nuevoEvento">
        <div class="modal-card" style="height: 80vh">
          <header class="modal-card-head">
            <p class="modal-card-title">Crear evento</p>
          </header>
          <section class="modal-card-body">
            <b-field label="Título del evento">
              <b-input
                type="text"
                placeholder="Introduce el título"
                v-model="datosNuevoEvento.title"
                required
              ></b-input>
            </b-field>

            <b-field label="Introduce comienzo">
              <datetime
                rounded
                placeholder="Click para introducir..."
                icon="calendar-today"
                horizontal-time-picker
                v-model="datosNuevoEvento.start"
                required
              ></datetime>
            </b-field>
            <b-field label="Introduce finalización">
              <datetime
                rounded
                placeholder="Click para introducir..."
                icon="calendar-today"
                horizontal-time-picker
                v-model="datosNuevoEvento.end"
                required
              ></datetime>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button
              class="button"
              type="button"
              @click="mostrarModalNuevoEvento = false"
            >
              Cerrar
            </button>
            <button class="button is-primary">Crear evento</button>
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
// import "vue-cal/dist/i18n/es.js";
// import "vue-cal/dist/drag-and-drop.js";
import datetime from 'vuejs-datetimepicker';
import Vue from "vue";
const moment = require('moment');

export default Vue.extend({
  components: { VueCal, datetime },
  created() {
    this.cogerEventos();
  },
  data() {
    return {
      events: [],
      datosNuevoEvento: {
        start: "",
        end: "",
        title: "",
        id: "",
        content: "<span class='icon icon has-text-primary is-medium'><i class='mdi mdi-briefcase mdi-36px'></i></span>",
        class: 'sport',
        idUsuario: "",
        fechaCreacion: "",
        deletable: true,
        resizable: true,
        draggable: false,
        esNuevo: true,
        esModificacion: false
      },
      mostrarModalNuevoEvento: false
    };
  },
  methods: {
    cogerEventos() {
      this.axios
        .get("/Agenda/GetAgenda", {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`
          }
        })
        .then(res => (this.events = JSON.parse(res.data.datos)))
        .catch(err => console.log(err));
    },
    guardarEventos(preguntar) {
      var guardarElementos = false;
      if(preguntar){
        if(confirm("¿Desea guardar los cambios realizados?")){
            guardarElementos = true;
        }
      }else{
        guardarElementos = true;
      }
      if(guardarElementos){
          this.axios.post("/Agenda/GuardaAgenda", { data: JSON.stringify(this.events) }, { headers: { Authorization: `Bearer ${this.$store.state.jwt}`}})
            .then((e) => {
              if(e.data == 2){
                  this.$ics.addEvent("es-ES", this.datosNuevoEvento.title, this.datosNuevoEvento.title, "Sala Reuniones", moment(this.datosNuevoEvento.start).format('YYYY/MM/DD HH:mm'), moment(this.datosNuevoEvento.end).format('YYYY/MM/DD HH:mm'), "", "", "");
                  this.$ics.download("Agregar evento Calendario Office 365 - Agenda de Sala de Reuniones");  
              }

              this.mostrarModalNuevoEvento = false;
              this.datosNuevoEvento.start = null;
              this.datosNuevoEvento.end = null;              
              this.datosNuevoEvento.title = "";
              this.datosNuevoEvento.id = "";              
              this.datosNuevoEvento.content = "";
              this.datosNuevoEvento.class = "";
              this.datosNuevoEvento.idUsuario = "";
              this.datosNuevoEvento.fechaCreacion = "";
              this.datosNuevoEvento.deletable = true;
              this.datosNuevoEvento.resizable = true;
              this.datosNuevoEvento.draggable = false;
              this.datosNuevoEvento.esNuevo = true;
              this.datosNuevoEvento.esModificacion = false;              
            }).catch(err => console.log(err));
      }
    },
    formateoFechaHora(m) {
      const dateString =
        m.getUTCFullYear() +
        "/" +
        (m.getUTCMonth() + 1) +
        "/" +
        m.getUTCDate() +
        " " +
        m.getUTCHours() +
        ":" +
        m.getUTCMinutes();
      return dateString;
    },
    nuevoEvento(){
      this.events.push({
        start: this.datosNuevoEvento.start,
        end: this.datosNuevoEvento.end,
        title: this.datosNuevoEvento.title,
        id: Date.now(),
        content: this.datosNuevoEvento.content,
        class: this.datosNuevoEvento.class,
        idUsuario: "",
        fechaCreacion: "",
        deletable: true,
        resizable: true,
        draggable: false,
        esNuevo: this.datosNuevoEvento.esNuevo,
        esModificacion: this.datosNuevoEvento.esModificacion        
      });
      this.guardarEventos(false);
    },
    getToday(){
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; 
        var year = today.getFullYear();      
        if(dd<10) {
            dd='0'+dd;
        } 

        if(mm<10) {
            mm='0'+mm;
        } 
        return (year + '-' + mm + '-' + dd);
    },
    onEventClick (event, e) {      
      if(confirm("¿Desea eliminar el evento y guardar los cambios realizados?")){
            this.events.splice(this.events.indexOf(event), 1);
            this.guardarEventos(false);
      }
      e.stopPropagation();
    },
    ModificaTexto(oldTitle, event){
      if(confirm("¿Desea modificar el titulo del evento y guardar los cambios realizados?")){
          this.events.splice(this.events.indexOf(event.event), 1);
          event.event.esNuevo = true;
          this.events.push(event.event);
          this.guardarEventos(false);
      }
      e.stopPropagation();
    },
    ModificaTiempo(oldDate, event){
      if(confirm("¿Desea modificar el tiempo del evento y guardar los cambios realizados?")){
          this.events.splice(this.events.indexOf(event.event), 1);
          event.event.esNuevo = true;
          event.event.esModificacion = true;
          this.events.push(event.event);
          this.guardarEventos(false);
      }
      e.stopPropagation();
    }
  }
});
</script>

<style type="text/css">

.vuecal__event-title {
  font-size: 1.2em;
  font-weight: bold;
  margin: 4px 0 8px;
  color:white;
}

.vuecal__event-time {
  display: inline-block;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  color:white;
}

.vuecal__event-content {
  font-style: italic;
}

i{
  background-color: white;
}

div.vuecal__event {
  font-style: italic;
  background-color: #ED6B24 !important;
}

div.vuecal__event:hover {
  font-style: italic;
  background-color: #ED6B24 !important;
  cursor: pointer;
}

 .vuecal__title-bar{
   background-color: #ED6B24 !important;
   color:white;
   font-weight: bold;
 }

.btn {
  position: fixed;
  bottom: 10px;
  right: 10px;
}

.vuecal__title-bar{
  background-color: orange mpor !important;
}

.vuecal__event.lunch {
  background: repeating-linear-gradient(45deg, transparent, transparent 10px, #f2f2f2 10px, #f2f2f2 20px);/* IE 10+ */
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vuecal__event.lunch .vuecal__event-time {display: none;align-items: center;}

</style>
